import { render, staticRenderFns } from "./ClienteCompras.vue?vue&type=template&id=43f84f4c&"
import script from "./ClienteCompras.vue?vue&type=script&lang=js&"
export * from "./ClienteCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports